<template>
  <div class="container" v-if="!store.loggedIn">
    <img class="logo" src="/static/img/KovoHome_text_white.svg" alt="">
    <div>
      <div class="forgotPasswordContainer cardBackground">
        <h1>Reset Password</h1>
        <p v-if="!submitted" class="description">Enter your email address and we'll send you a link to reset your password.</p>
        <div v-if="!submitted" class="emailContainer">
          <h3>Email Address</h3>
          <input
            class="loginInput"
            type="email"
            v-model="email"
            @keyup.enter="requestReset"
            style="border-color: #45403C;"
            placeholder="your@email.com"
          >
        </div>
        <div v-if="submitted" class="successMessage">
          <svg class="successIcon"><use href="/static/icons/Check.svg#Check"/></svg>
          <p class="mainSuccessText">If an account exists with that email, you will receive a password reset link shortly.</p>
          <p class="note">Please check your spam folder if you don't see the email.</p>
        </div>
        <div v-if="!submitted">
          <button
            class="specialButton"
            @click="requestReset"
            :disabled="loading"
            style="color: var(--text-primary); background-color: var(--color-secondary-button)"
          >
            {{ loading ? 'Sending...' : 'Send Reset Link' }}
          </button>
        </div>
        <div class="backToLogin">
          <router-link to="/login" class="linkButton">
            Back to Login
          </router-link>
        </div>
      </div>
    </div>
    <div></div>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
    <LoadingPage :is-visible="loading"/>
  </div>
</template>

<script>
import { useLoginStore } from "@/stores/loginStore";
import APIService from "@/servicehandlers/APIService";
import MessageModal from "@/components/MessageModal.vue";
import LoadingPage from "@/components/LoadingPage.vue";

const apiService = new APIService();

export default {
  name: 'ForgotPasswordPage',
  components: {
    LoadingPage,
    MessageModal,
  },
  data(){
    return {
      loading: false,
      submitted: false,
      appMessage: {
        text: '',
        type: 'error',
      },
      email: '',
      store: useLoginStore()
    }
  },
  mounted() {
    if (this.store.loggedIn){
      this.$router.push({ name: 'dashboard' });
    }
  },
  methods: {
    async requestReset(){
      if (!this.email) {
        this.appMessage.text = 'Please enter your email address';
        this.appMessage.type = 'error';
        this.$refs.messageModal.open();
        return;
      }

      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.appMessage.text = 'Please enter a valid email address';
        this.appMessage.type = 'error';
        this.$refs.messageModal.open();
        return;
      }

      this.loading = true;

      try {
        const response = await apiService.post('/password-reset/request', {
          email: this.email
        });

        if (response) {
          this.submitted = true;
        }
      } catch (error) {
        console.error('Password reset request error:', error);
        this.appMessage.text = 'An error occurred. Please try again later.';
        this.appMessage.type = 'error';
        this.$refs.messageModal.open();
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped>
.logo {
  display: block;
  margin: 2rem auto;
  width: 100%;
  height: auto;
  margin-top: 7rem;
}

.forgotPasswordContainer{
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  margin: 30px;
  max-width: 500px;
  border-radius: 12px;
  padding: 20px;
}

.description {
  text-align: center;
  color: var(--text-primary);
  margin: 0;
  font-size: 14px;
}

.emailContainer{
  width: 100%;
}

input{
  font-size: 20px;
  height: 50px;
  width: 100%;
}

h3{
  text-align: left;
  margin-bottom: 10px;
}

.successMessage {
  text-align: center;
  padding: 20px;
  color: var(--text-primary);
}

.successIcon {
  width: 60px;
  height: 60px;
  color: #4CAF50;
  margin-bottom: 20px;
}

.mainSuccessText {
  font-size: 32px;
}

.note {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 15px;
}

.backToLogin {
  margin-top: 10px;
}

.linkButton {
  color: var(--color-secondary-button);
  text-decoration: none;
  font-size: 27px;
}

.linkButton:hover {
  text-decoration: underline;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
